import {
  Button,
  Card,
  ChatBubbleLeftEllipsisIcon,
  ErrorAlert,
  Input,
  danger,
  success,
  useCustomForm,
  useFetchData,
} from "@";
import IntegrationShell from "../shared/IntegrationShell";
import { getWhatsappSettings, saveWhatsappSettings } from "../shared/api";
import { defaultValues, schema } from "./utils/validation";

const PROVIDERS = [
  {
    key: "wati",
    name: "Wati",
    description: "منصة WhatsApp Business مع قوالب وردود تلقائية.",
  },
  {
    key: "autorply",
    name: "Autorply",
    description: "ردود WhatsApp تلقائية وحملات مجدوَلة.",
  },
];

const Index = () => {
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  const { error, fetchData } = useFetchData({
    reset,
    fun: getWhatsappSettings,
  });

  const provider = watch("provider");

  const submit = async (data) => {
    try {
      await saveWhatsappSettings(data);
      success("تم حفظ إعدادات مزوّد WhatsApp");
    } catch (err) {
      danger("تعذّر حفظ الإعدادات. تحقق من القيم وحاول مجدداً.");
    }
  };

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />

      <IntegrationShell
        eyebrow="الإعدادات / التكاملات"
        title="مزوّدو WhatsApp"
        icon={ChatBubbleLeftEllipsisIcon}
        breadcrumbName="مزوّدو WhatsApp"
        providers={PROVIDERS}
        active={provider}
        onActiveChange={(key) => setValue("provider", key)}
        isSaving={isSubmitting}
      >
        <form onSubmit={handleSubmit(submit)} className="mt-2">
          {provider === "wati" && (
            <Card title="إعدادات Wati">
              <div className="grid gap-5 md:grid-cols-2">
                <div className="md:col-span-2">
                  <Input
                    star
                    label="API Endpoint"
                    placeholder="https://live-server-XXXX.wati.io"
                    error={errors.watiApiEndpoint}
                    input={register("watiApiEndpoint")}
                  />
                </div>
                <div className="md:col-span-2">
                  <Input
                    star
                    type="textarea"
                    rows={3}
                    label="Access Token"
                    placeholder="Bearer eyJhbGciOi..."
                    error={errors.watiAccessToken}
                    input={register("watiAccessToken")}
                  />
                </div>
                <div className="md:col-span-2">
                  <Input
                    label="Tenant ID"
                    placeholder="اختياري — للحسابات متعددة المستأجرين"
                    error={errors.watiTenantId}
                    input={register("watiTenantId")}
                  />
                </div>
              </div>
            </Card>
          )}

          {provider === "autorply" && (
            <Card title="إعدادات Autorply">
              <div className="grid gap-5 md:grid-cols-2">
                <Input
                  star
                  type="password"
                  label="API Key"
                  placeholder="ak_live_..."
                  error={errors.autorplyApiKey}
                  input={register("autorplyApiKey")}
                />
                <Input
                  star
                  label="رقم المُرسِل"
                  placeholder="+9665XXXXXXXX"
                  error={errors.autorplySenderNumber}
                  input={register("autorplySenderNumber")}
                />
              </div>
            </Card>
          )}

          <div className="mt-5 flex items-center justify-end gap-3">
            <p className="hidden text-xs text-gray-500 dark:text-gray-400 sm:block">
              سيُستخدم المزوّد المختار لإرسال كل رسائل WhatsApp.
            </p>
            <Button
              type="submit"
              title="حفظ الإعدادات"
              isLoading={isSubmitting}
            />
          </div>
        </form>
      </IntegrationShell>
    </>
  );
};

export default Index;
